var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncIterator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var pull = require('pull-stream/pull');

var values = require('pull-stream/sources/values');

var importer = require('ipfs-unixfs-importer');

var toIterator = require('pull-stream-to-async-iterator');

var toPull = require('async-iterator-to-pull-stream');

var getIterator = require('get-iterator');

var CID = require('cids');

var IPLD = require('ipld');

var inMemory = require('ipld-in-memory');

exports.of = function _callee(input, options) {
  var ipld, source, it, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, _value2, multihash;

  return _regeneratorRuntime.async(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          options = options || {};
          options.onlyHash = true;
          _context.next = 4;
          return _regeneratorRuntime.awrap(new Promise(function (resolve, reject) {
            inMemory(IPLD, function (err, ipld) {
              if (err) return reject(err);
              resolve(ipld);
            });
          }));

        case 4:
          ipld = _context.sent;
          source = values([{
            content: Buffer.isBuffer(input) ? input : toPull(getIterator(input))
          }]);
          it = toIterator(pull(source, importer(ipld, options)));
          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _context.prev = 9;
          _iterator = _asyncIterator(it);

        case 11:
          _context.next = 13;
          return _regeneratorRuntime.awrap(_iterator.next());

        case 13:
          _step = _context.sent;
          _iteratorNormalCompletion = _step.done;
          _context.next = 17;
          return _regeneratorRuntime.awrap(_step.value);

        case 17:
          _value = _context.sent;

          if (_iteratorNormalCompletion) {
            _context.next = 24;
            break;
          }

          _value2 = _value, multihash = _value2.multihash;
          return _context.abrupt("return", new CID(multihash).toString());

        case 21:
          _iteratorNormalCompletion = true;
          _context.next = 11;
          break;

        case 24:
          _context.next = 30;
          break;

        case 26:
          _context.prev = 26;
          _context.t0 = _context["catch"](9);
          _didIteratorError = true;
          _iteratorError = _context.t0;

        case 30:
          _context.prev = 30;
          _context.prev = 31;

          if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
            _context.next = 35;
            break;
          }

          _context.next = 35;
          return _regeneratorRuntime.awrap(_iterator.return());

        case 35:
          _context.prev = 35;

          if (!_didIteratorError) {
            _context.next = 38;
            break;
          }

          throw _iteratorError;

        case 38:
          return _context.finish(35);

        case 39:
          return _context.finish(30);

        case 40:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, [[9, 26, 30, 40], [31,, 35, 39]]);
};